<template>
    <div class="search-input-wrap" :class="{'is-round': round}">
        <el-input
            @keydown.native.enter.stop="onSearch"
            :placeholder="placeholder"
            :maxlength="maxlength"
            v-model="currentValue">
            <i @click="onSearch" slot="suffix" class="el-input__icon el-icon-search search-btn"></i>
        </el-input>
    </div>
</template>

<script>
export default {
  name: 'h-search-input',
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    round: {
      type: Boolean,
      default: true
    },
    maxlength: {
      type: Number,
      default: Infinity
    },
    controlled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (val) {
      if (this.currentValue !== val) this.currentValue = val
    },
    currentValue () {
      if (this.controlled) {
        this.$emit('input', this.currentValue)
      }
    }
  },
  data () {
    return {
      currentValue: ''
    }
  },
  methods: {
    onSearch () {
      this.$emit('input', this.currentValue)
      this.$emit('search', this.currentValue)
    }
  }
}
</script>

<style lang="less">
.search-input-wrap {
    width: 240px;
    &.is-round {
      .el-input.el-input--small {
        .el-input__inner {
          border-radius: 16px;
        }
      }
    }
    .search-btn {
      cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/search-input.vue